module.exports = __webpack_public_path__ + "img/4.c4b5b2ae.jpg";